import { useCompetitionTeamDetailQuery } from './queries';
import { TeamDivisionResultTable } from './components/team-result-table';
import { Panel } from '~/components/Panel/Panel';
import { Fragment } from 'react/jsx-runtime';

interface Props {
  competitionId: number;
}

export function CompetitionTeamResultPage({ competitionId }: Props) {
  const { data, isLoading } = useCompetitionTeamDetailQuery(competitionId);

  if (isLoading || !data) {
    return false;
  }

  if (data.results.length === 0) {
    return (
      <Panel variant="informative" size="sm">
        <p>Inga lagresultat ännu.</p>
      </Panel>
    );
  }

  return (
    <Fragment>
      {data.results.map((division, idx) => (
        <TeamDivisionResultTable key={division.id ?? `division-${idx}`} division={division} />
      ))}
    </Fragment>
  );
}
